export const validatePassword = (password: string): boolean => {
  const minLength = 8;
  const hasLetter = /[a-zA-Z]/.test(password);
  const hasNumber = /\d/.test(password);
  // Будь-які символи дозволені — вимагаємо лише довжину + літеру + цифру.
  return password.length >= minLength && hasLetter && hasNumber;
};

export const validateOldPassword = (password: string): boolean => {
  const minLength = 8;
  return password.length >= minLength;
};

export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};
